var map = {
	"./margins_landscape_large.png": 2594,
	"./margins_landscape_small.png": 43403,
	"./margins_landscape_zero.png": 69321,
	"./margins_portrait_large.png": 99022,
	"./margins_portrait_small.png": 50699,
	"./margins_portrait_zero.png": 96412,
	"./margins_square_large.png": 76066,
	"./margins_square_small.png": 30620,
	"./margins_square_zero.png": 89808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61321;